import React, {useContext, useState} from 'react';
import {PAContext} from "../../../Services/PAContext";
import {useGoogleAutocompleteForAddress} from "../../Helpers/GoogleAutocomplete";
import {
    Alert,
    Autocomplete,
    Avatar,
    Box, Button, CircularProgress, Collapse,
    FormControl,
    InputAdornment,
    InputLabel,
    MenuItem, Paper,
    Select, Snackbar,
    Switch,
    TextField, Zoom, alpha
} from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import country_codes from "../../../sampleData/PhonePrefixes";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {supportedLanguages} from "../../../sampleData/PreferredLanguages";
import {_airports_list} from "../../../sampleData/airline_data";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import LockIcon from "@mui/icons-material/Lock";
import {Stack} from "@mui/system";
import DevicesIcon from '@mui/icons-material/Devices';
import {
    Security as SecurityIcon,
    History as HistoryIcon,
    Login as LoginIcon,
    InfoOutlined as InfoIcon
} from '@mui/icons-material';



function Profile({processingProfile, setProcessingProfile, snackbar, setSnackbar}){

    const { dataArray, sendSocketMessage } = useContext(PAContext);
    const { Account } = dataArray;

    const [avatarSnackbar, setAvatarSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const [fname,setFname] = useState(Account.fname);
    const [lname,setLname] = useState(Account.lname);
    const [nickname,setNickname] = useState(Account.nickname);
    const [email,setEmail] = useState(Account.email);
    const [phonePrefix,setPhonePrefix] = useState(Account.phone_prefix);
    const [phone,setPhone] = useState(Account.phone);
    const [dob,setDOB] = useState(Account.dob);
    const [language,setLanguage] = useState(Account.language);
    const [preferredAirport,setPreferredAirport] = useState(Account.preferred_airport);

    // Function to handle file input click on avatar
    const [ attendeeAvatar, setAttendeeAvatar] = useState(Account.avatar);
    // Function to handle file change and set the avatar
    const handleImageChange = (event, id) => {
        const file = event.target.files[0];
        if (!file) return;

        // 1. Define limits (4MB server limit, so we check raw file at ~3MB to account for Base64 bloat)
        const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB

        if (file.size > MAX_FILE_SIZE) {
            setAvatarSnackbar({
                open: true,
                message: `Image is too large (${(file.size / (1024 * 1024)).toFixed(1)}MB). Please select an image under 3MB.`,
                severity: 'error'
            });

            // Reset the input so the same file can be picked again if they resize it
            event.target.value = null;
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result;

            setAttendeeAvatar(prev => (
                {
                    preview: base64data, // This is base64 string of image
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    hasBeenUpdated: true,
                }
            ));

        };

        reader.readAsDataURL(file);
    };

    const [addressFieldsResidential, setAddressFieldsResidential] = useState({
        google_place_id: '',
        latitude: 0,
        longitude: 0,
        formatted_address: '',
        address: Account.address,
        city: Account.city,
        state: Account.state,
        zip: Account.zip,
        country: Account.country,
    });
    const { inputRefResidential, attachAutocompleteResidential, removePacContainerResidential } = useGoogleAutocompleteForAddress((parsedAddress) => {
        setAddressFieldsResidential({
            google_place_id: parsedAddress.google_place_id,
            latitude: parsedAddress.latitude,
            longitude: parsedAddress.longitude,
            formatted_address: parsedAddress.formatted_address,
            address: parsedAddress.address,
            city: parsedAddress.city,
            state: parsedAddress.state,
            zip: parsedAddress.zip,
            country: parsedAddress.country,
        });
    });

    function handleFnameChange(event){
        setFname(event.target.value);
    }
    function handleLnameChange(event){
        setLname(event.target.value);
    }
    function handleNicknameChange(event){
        setNickname(event.target.value);

    }
    const handleAddressComponentChange = (e) => {
        const { name, value } = e.target;
        setAddressFieldsResidential((prev) => ({ ...prev, [name]: value }));
    };
    function handleAddressCountryChange(event){
        setAddressFieldsResidential((prev) => ({ ...prev, ['country']: event.target.value }));
    }
    function handleEmailChange(event){
        setEmail(event.target.value);
    }
    function handlePhonePrefixChange(event){
        console.log("setting phone prefix to : "+event.target.value);
        setPhonePrefix(event.target.value);
    }
    function handlePhoneChange(event){
        console.log("setting phone prefix to : "+event.target.value);

        if (phonePrefix === "+1"){
            //format for area code
            const input = event.target.value.replace(/\D/g, ''); // Remove non-numeric characters
            let formattedNumber = input;

            if (input.length >= 3) {
                formattedNumber = `(${input.slice(0, 3)})`;

                if (input.length > 3) {
                    formattedNumber += ` ${input.slice(3, 6)}`;

                    if (input.length > 6) {
                        formattedNumber += `-${input.slice(6, 10)}`;
                    }
                }
            }
            setPhone(formattedNumber);
        } else {
            setPhone(event.target.value);
        }

    }
    function handleDOBChange(newValue){
        if (newValue && newValue.isValid()) {
            setDOB(newValue.format('YYYY-MM-DD'));
        } else {
            setDOB(""); // Or null, depending on your use case
        }
    }
    function handleLanguageChange(event){
        setLanguage(event.target.value);
    }
    function handlePreferredAirportChange(event){
        console.log("changed preferred airport to : "+ event.target.value);
        setPreferredAirport(event.target.value);
    }

    const [autoLogin,setAutoLogin] = useState(Account.auto_login);

    const [passwordSnackbar, setPasswordSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [showPasswordSection, setShowPasswordSection] = useState(false);
    const [passwords, setPasswords] = useState({ current: '', next: '', confirm: '' });
    const [showPwd, setShowPwd] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const allowedSpecialChars = "@$!%*#?&";
    function encode64(input) {
        if (!input) return "";

        // First, we use TextEncoder to convert the string to a UTF-8 byte array.
        // Then, we convert those bytes to a string where each character
        // represents one byte (using map/fromCharCode).
        // Finally, btoa() creates the Base64 string.
        const bytes = new TextEncoder().encode(input);
        const binString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join("");
        return btoa(binString);
    }

    /**
     * Helper to format the Unix timestamp into a readable date
     */
    const formatLastLogin = (ts) => {
        if (!ts) return "Never";
        return new Date(ts).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };
    const formatLastChange = (ts) => {
        if (!ts) return "Never";
        return new Date(ts).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    function handleSaveAccountEdit(){

        //send to server
        const _sendString = {};
        _sendString.action = "E_updateAccountPersonalInfo";

        _sendString.fname = fname;
        _sendString.lname = lname;
        _sendString.nickname = nickname;

        _sendString.address = addressFieldsResidential['address'];
        _sendString.city = addressFieldsResidential['city'];
        _sendString.state = addressFieldsResidential['state'];
        _sendString.zip = addressFieldsResidential['zip'];
        _sendString.country = addressFieldsResidential['country'];

        _sendString.email = email;
        _sendString.dob = dob;

        _sendString.phone_prefix = phonePrefix;
        _sendString.phone = phone.replace(/\D/g, '');

        _sendString.language = language;
        _sendString.preferred_airport = preferredAirport;

        /*
            only send the avatar if it has changed
         */
        if (attendeeAvatar && attendeeAvatar.hasBeenUpdated){
            _sendString.avatar = attendeeAvatar;
        }

        console.log("user profile : ", _sendString);
        sendSocketMessage(_sendString);

        //and if auto-login is enabled or not
        console.log("autoLogin : "+autoLogin+" : "+Account.auto_login);
        if (autoLogin !== Account.auto_login){
            //it did change so process the update
            const _send_string = {};
            _send_string.action = "E_updateAccountPersonalInfoAutoLogin";
            _send_string.auto_login = autoLogin;

            sendSocketMessage(_send_string);
        }

    }

    /**
     * Validates and submits the password change request
     */
    const handlePasswordSubmit = async () => {
        // 1. Basic Validation
        if (!passwords.current || !passwords.next || !passwords.confirm) {
            setPasswordSnackbar({ open: true, message: 'Please fill in all password fields.', severity: 'error' });
            return;
        }

        if (passwords.next !== passwords.confirm) {
            setPasswordSnackbar({ open: true, message: 'New passwords do not match.', severity: 'error' });
            return;
        }

        const passwordRegex = new RegExp(`^(?=.*[A-Za-z])(?=.*\\d)(?=.*[${allowedSpecialChars}])[A-Za-z\\d${allowedSpecialChars}]{8,}$`);

        if (!passwordRegex.test(passwords.next)) {
            setPasswordSnackbar({
                open: true,
                message: `Password must be 8+ chars with letters, numbers, and one special char: ${allowedSpecialChars}`,
                severity: 'error'
            });
            return;
        }

        setProcessingProfile(true);
        setIsSaving(true);

        try {

            //send to server
            const _sendString = {};
            _sendString.action = "E_updateAccountPersonalInfoPassword";
            _sendString.current_password = encode64(passwords['current']);
            _sendString.password = encode64(passwords['next']);
            _sendString.password_confirm = encode64(passwords['confirm']);

            sendSocketMessage(_sendString);

            setPasswords({ current: '', next: '', confirm: '' });
            setShowPasswordSection(false);

        } catch (error) {
            setPasswordSnackbar({ open: true, message: 'Failed to update password.', severity: 'error' });
        } finally {
            setIsSaving(false);
        }
    };



    return (
        <>
            {/* SAVE Button */}
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                <Button
                    variant="contained"
                    disabled={processingProfile}
                    startIcon={
                        processingProfile ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            <i className="icon-floppy-disk" />
                        )
                    }
                    onClick={handleSaveAccountEdit}
                    sx={{
                        bgcolor: '#f09637',
                        '&:hover': { bgcolor: '#d9822b' },
                        // Ensure the button maintains a consistent width when switching to the spinner
                        minWidth: '140px'
                    }}
                >
                    Save Profile
                </Button>
            </Box>

            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4}}>
                <input
                    type="file"
                    id={`file-input-new-attendee`}
                    accept="image/*"
                    style={{display: 'none'}}
                    onChange={(e) => handleImageChange(e)}
                />
                <Avatar
                    src={
                        attendeeAvatar?.preview || ''
                    }
                    alt="Attendee Avatar"
                    sx={{width: 150, height: 150, cursor: 'pointer'}}
                    onClick={() => document.getElementById('file-input-new-attendee').click()}
                />
                <Typography variant="body2" color="text.secondary">
                    Click avatar to upload or replace
                </Typography>

                <Box sx={{ width: '100%', maxWidth: '280px' }}>
                    <Collapse in={avatarSnackbar.open}>
                        <Alert
                            severity={avatarSnackbar.severity}
                            variant="filled"
                            onClose={() => setAvatarSnackbar({ ...avatarSnackbar, open: false })}
                            sx={{
                                mt: 1.5,
                                borderRadius: '12px',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                        >
                            {avatarSnackbar.message}
                        </Alert>
                    </Collapse>
                </Box>
            </Box>
            <Grid container spacing={2}>
                <TextField fullWidth id="fname" label="First Name" required value={fname} onChange={handleFnameChange}/>
                <TextField fullWidth id="lname" label="Last Name" required value={lname} onChange={handleLnameChange}/>
                <TextField fullWidth id="nickname" label="Nickname" value={nickname} onChange={handleNicknameChange}/>
                <TextField fullWidth id="address" name="address" label="Address"
                           value={addressFieldsResidential.address}
                           onChange={handleAddressComponentChange}
                           inputRef={inputRefResidential}
                           onFocus={attachAutocompleteResidential}
                           onBlur={removePacContainerResidential}
                />
                <TextField fullWidth id="city" name="city" label="City" value={addressFieldsResidential.city} onChange={handleAddressComponentChange} />
                <TextField fullWidth id="state" name="state" label="State" value={addressFieldsResidential.state} onChange={handleAddressComponentChange} />
                <TextField fullWidth id="zip" name="zip" label="Zip" value={addressFieldsResidential.zip} onChange={handleAddressComponentChange} />

                <FormControl fullWidth>
                    <InputLabel id="prefix-label">Country</InputLabel>
                    <Select
                        labelId="prefix-label"
                        id="country-select"
                        value={addressFieldsResidential.country.toUpperCase()}
                        onChange={handleAddressCountryChange}
                        label="Country"
                    >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {country_codes.map((item, index) => (
                            <MenuItem key={index} value={item.isoCode}>
                                <img
                                    src={item.flag}
                                    alt={`${item.name} flag`}
                                    style={{
                                        width: 20,
                                        height: 15,
                                        marginRight: 8,
                                        objectFit: 'cover',
                                        borderRadius: '2px',
                                    }}
                                />
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField fullWidth id="email_address" label="*Email" type="email" value={email} onChange={handleEmailChange} helperText="* Required for logging in" />

                <FormControl fullWidth>
                    <InputLabel id="prefix-label">Phone Prefix</InputLabel>
                    <Select
                        labelId="prefix-label"
                        id="phone-prefix-select"
                        value={phonePrefix}
                        onChange={handlePhonePrefixChange}
                        label="Phone Prefix"
                    >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {country_codes.map((item, index) => (
                            <MenuItem key={index} value={item.dialCode}>
                                {item.dialCode} : {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField fullWidth id="phone" label="Phone" value={phone} onChange={handlePhoneChange} />

                <DatePicker
                    sx={{width: '100%'}}
                    label="Date of Birth"
                    value={dob ? dayjs(dob, 'YYYY-MM-DD') : null}
                    onChange={handleDOBChange}
                />

                <FormControl fullWidth>
                    <InputLabel id="language-label">Preferred Language</InputLabel>
                    <Select
                        labelId="language-label"
                        id="preferred-language-select"
                        value={language}
                        label="Preferred Language"
                        onChange={handleLanguageChange}
                    >
                        {supportedLanguages.map((lang) => (
                            <MenuItem key={lang.code} value={lang.code}>
                                {lang.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Autocomplete
                    fullWidth
                    options={_airports_list}
                    getOptionLabel={(option) => `${option.iata} : ${option.name}`}
                    value={_airports_list.find((item) => item.iata === preferredAirport) || null}
                    onChange={(event, newValue) => {
                        handlePreferredAirportChange({ target: { value: newValue ? newValue.iata : '' } });
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label="Preferred Airport" />
                    )}
                    isOptionEqualToValue={(option, value) => option.iata === value.iata}
                />

            </Grid>


            {/* Isolated Auto-Login Section */}
            <Paper
                elevation={0}
                sx={{
                    mt: 4,
                    p: 2.5,
                    borderRadius: '20px',
                    bgcolor: '#fff9f2',
                    border: '1px solid #ffe8cc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ p: 1.2, bgcolor: 'white', borderRadius: '12px', color: '#f09637', display: 'flex', boxShadow: '0 4px 10px rgba(240, 150, 55, 0.1)' }}>
                        <DevicesIcon />
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#1a1a1a' }}>Auto-Login Access</Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                            Enable auto-login. For your security, a manual sign-in is required once per new device.
                        </Typography>
                    </Box>
                </Box>
                <Switch
                    checked={autoLogin}
                    onChange={(e) => setAutoLogin(e.target.checked)}
                    color="warning"
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#f09637' },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#f09637' }
                    }}
                />
            </Paper>


            {/* Password Update Section */}
            <Divider sx={{ my: 4, '&::before, &::after': { borderColor: '#f0f0f0' } }}>
                <SecurityIcon sx={{ color: '#f0f0f0', fontSize: 20 }} />
            </Divider>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 900, color: '#1a1a1a', display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Box sx={{ width: 4, height: 16, bgcolor: '#f09637', borderRadius: 1 }} />
                        Login Password Security
                    </Typography>

                    <Stack spacing={0.8}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#f8f9fa', px: 1, py: 0.5, borderRadius: '6px', width: 'fit-content' }}>
                            <LoginIcon sx={{ fontSize: 12, color: '#6366f1' }} />
                            <Typography variant="caption" sx={{ color: '#4b5563', fontWeight: 700, fontSize: '0.65rem' }}>
                                LAST LOGIN: {formatLastLogin(Account.last_login)}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#fff7ed', px: 1, py: 0.5, borderRadius: '6px', width: 'fit-content' }}>
                            <HistoryIcon sx={{ fontSize: 12, color: '#f09637' }} />
                            <Typography variant="caption" sx={{ color: '#9a3412', fontWeight: 700, fontSize: '0.65rem' }}>
                                PASSWORD LAST CHANGED: {formatLastChange(Account.last_password_change)}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>

                <Button
                    size="small"
                    variant={showPasswordSection ? "outlined" : "text"}
                    onClick={() => setShowPasswordSection(!showPasswordSection)}
                    startIcon={<LockIcon sx={{ fontSize: 14 }} />}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 800,
                        borderRadius: '12px',
                        px: 2,
                        color: showPasswordSection ? '#ef4444' : '#f09637',
                        borderColor: showPasswordSection ? '#fecaca' : 'transparent',
                        '&:hover': {
                            bgcolor: showPasswordSection ? '#fef2f2' : alpha('#f09637', 0.05),
                            borderColor: showPasswordSection ? '#ef4444' : 'transparent',
                        }
                    }}
                >
                    {showPasswordSection ? "Cancel" : "Update"}
                </Button>
            </Box>

            <Zoom in={showPasswordSection} unmountOnExit>
                <Box>
                    <Paper
                        elevation={0}
                        sx={{
                            p: 3,
                            bgcolor: '#fafafa',
                            borderRadius: '24px',
                            border: '1px solid #f0f0f0',
                            mb: 2,
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0, left: 0, right: 0, height: '4px',
                                bgcolor: '#f09637'
                            }
                        }}
                    >
                        <Stack spacing={2.5}>
                            {/* Requirement Notice */}
                            <Box sx={{ display: 'flex', gap: 1.5, bgcolor: '#fff', p: 1.5, borderRadius: '12px', border: '1px solid #eee' }}>
                                <InfoIcon sx={{ color: '#f09637', fontSize: 18 }} />
                                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, lineHeight: 1.3 }}>
                                    Password must be 8+ characters, including letters, numbers, and one of:
                                    <Box component="span" sx={{ color: '#f09637', ml: 0.5, fontWeight: 900, letterSpacing: '0.1em' }}>
                                        {allowedSpecialChars}
                                    </Box>
                                </Typography>
                            </Box>
                            <TextField
                                fullWidth
                                variant="standard"
                                type={showPwd ? 'text' : 'password'}
                                label="Verify Current Password"
                                value={passwords.current}
                                onChange={(e) => setPasswords({...passwords, current: e.target.value})}
                                InputLabelProps={{ sx: { fontWeight: 700, fontSize: '0.8rem' } }}
                                sx={{ '& .MuiInput-root': { mt: 1 } }}
                            />

                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    type={showPwd ? 'text' : 'password'}
                                    label="New Password"
                                    value={passwords.next}
                                    onChange={(e) => setPasswords({...passwords, next: e.target.value})}
                                    InputLabelProps={{ sx: { fontWeight: 700, fontSize: '0.8rem' } }}
                                />
                                <TextField
                                    fullWidth
                                    variant="standard"
                                    type={showPwd ? 'text' : 'password'}
                                    label="Confirm"
                                    value={passwords.confirm}
                                    onChange={(e) => setPasswords({...passwords, confirm: e.target.value})}
                                    InputLabelProps={{ sx: { fontWeight: 700, fontSize: '0.8rem' } }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton size="small" onClick={() => setShowPwd(!showPwd)}>
                                                    {showPwd ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                onClick={handlePasswordSubmit}
                                disabled={isSaving}
                                disableElevation
                                sx={{
                                    py: 1.5,
                                    bgcolor: '#1a1a1a',
                                    borderRadius: '14px',
                                    textTransform: 'none',
                                    fontWeight: 800,
                                    fontSize: '0.9rem',
                                    '&:hover': { bgcolor: '#000' }
                                }}
                            >
                                {isSaving ? <CircularProgress size={20} color="inherit" /> : "Confirm New Security Credentials"}
                            </Button>

                            <Collapse in={passwordSnackbar.open}>
                                <Alert
                                    severity={passwordSnackbar.severity}
                                    variant="filled"
                                    onClose={() => setPasswordSnackbar({ ...passwordSnackbar, open: false })}
                                    sx={{
                                        borderRadius: '12px',
                                        fontWeight: 700,
                                        fontSize: '0.75rem',
                                        bgcolor: passwordSnackbar.severity === 'success' ? '#10b981' : '#ef4444'
                                    }}
                                >
                                    {passwordSnackbar.message}
                                </Alert>
                            </Collapse>
                        </Stack>
                    </Paper>
                </Box>
            </Zoom>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert severity={snackbar.severity} sx={{ width: '100%', borderRadius: '12px', fontWeight: 600 }}>{snackbar.message}</Alert>
            </Snackbar>
        </>
    )

}

export default Profile;